<template lang="html" @click="closeAllTodos()">
  <div class="screen projects" :class="[`${pageColor}-bg`]">
    <h1 v-if="$store.state.projects.length === 0" key="emptyheading" >organize your rhythms into projects to keep a better overview.</h1>
    <h1 v-if="$store.state.projects.length > 0" key="fullheading" >every single rhythm brings you closer to accomplish your projects.</h1>

    <transition-group v-if="$store.state.projects.length > 0" class="project-list" tag="div">
      <div v-for="project in $store.state.projects" :key="project.id">
        <header class="header">
          <TodoButton
            class="showTodosButton"
            :class="{ active: activeProject === project.id }"
            :label="project.name"
            icon="projectIcon"
            @click="todosForAProject(project.id)"
          />
          <div class="projectButtons">
            <button class="projectButton" type="button" @click="handleEditProject(project)" >
              <TodoIcon class="projectIcon" :icon="'edit'"/>
            </button>
            <button class="projectButton" type="button" @click="deleteProject(project.id)">
              <TodoIcon class="projectIcon" :icon="'delet'"/>
            </button>
          </div>
        </header>

        <transition-group v-if="activeProject === project.id && showTodo" class="todo-list" tag="div">
          <TodoItem
            class ="todo-item"
            :class="[pageColor]"
            v-for="todo in $store.state.loadedTodos"
            :createdAt="todo.createdAt"
            :done="todo.done"
            :category="todo.category"
            :timeNeeded="todo.timeNeeded"
            :timeExpected="todo.timeExpected"
            :dueDate="todo.dueDate"
            :id="todo.id"
            :key="todo.id"
            :project="todo.project"
            :motive="todo.motive"
            :text="todo.text"
            :icon="todo.icon"
            @edit-todo="$emit('edit-todo', $event)"
            @done="checkTodo(todo.id)"
          />
        </transition-group>
      </div>
    </transition-group>
    <div v-if="$store.state.projects.length === 0" key="emptyState" @click="$emit('show-modal')">
      <div class="empty-state">
        <div class="start">
          <span>add new rhythms &amp; projects</span>
          <TodoIcon :icon="'down'"/>
        </div>
      </div>
    </div>
    <TodoProjectModal title="edit project" :visible="showTodoProjectModal" :name="projectBeingEdited && projectBeingEdited.name" @close="showTodoProjectModal = false" @confirm="saveProject"/>
  </div>
</template>

<script>
import TodoItem from '@/components/TodoItem.vue';
import TodoButton from '@/components/TodoButton.vue';
import TodoIcon from '@/components/TodoIcon.vue';
import TodoProjectModal from '@/components/TodoProjectModal.vue';

export default {
  name: 'projects',
  components: {
    TodoItem,
    TodoButton,
    TodoIcon,
    TodoProjectModal,
  },
  async created() {
    try {
      await this.$store.dispatch('loadProjects');
    } catch (err) {
      this.$store.commit('addToast', { message: `Sorry! An error occured when importing your rhythms in dependence of your projects: ${err.message}` });
    }
    window.addEventListener('click', this.closeAllTodos); // closes the todos for a project when clicked somwhere on the window
  },
  data() {
    return {
      projects: [],
      todos: [],
      showDone: Boolean,
      projectName: '',
      activeProject: null,
      showTodo: false,
      showTodoProjectModal: false,
      projectBeingEdited: null,
    };
  },
  methods: {
    async deleteProject(id) {
      try {
        await this.$store.dispatch('deleteProject', id);
        // hier auch noch todos löschen, die die gleiche id wie das gelöscht projekt haben
        this.$store.commit('addToast', { message: 'Your project and all related todos have been deleted.' });
      } catch (err) {
        this.$store.commit('addToast', { message: `Sorry. Could not delete Project and all related todos: ${err.message}` });
      }
    },
    async updateProjectName(id, newName) {
      if (!newName) return;
      try {
        await this.$store.dispatch('updateProject', { projectId: id, changes: { name: newName.toUpperCase() } });
      } catch (err) {
        this.$store.commit('addToast', { message: `Sorry. Could not rename Project: ${err.message}` });
      }
    },
    handleEditProject(project) {
      this.projectBeingEdited = project;
      this.showTodoProjectModal = true;
    },
    saveProject(newName) {
      this.updateProjectName(this.projectBeingEdited.id, newName);
      this.showTodoProjectModal = false;
    },
    closeAllTodos(e) {
      if (!this.$el.contains(e.target)) {
        this.showTodo = false;
      }
    },
    async todosForAProject(projectId) {
      if (this.activeProject === projectId) {
        // this.showTodo = false;
      } else {
        this.showTodo = false;
      }
      await this.$store.dispatch('loadTodosForProject', projectId);
      // it would be clean to only load the projects once
      this.activeProject = projectId;
      this.showTodo = !this.showTodo;
    },
    checkTodo(todoId) {
      this.$store.dispatch('checkTodo', todoId);
    },
    deleteTodo(todoId) {
      this.$store.dispatch('deleteTodo', todoId);
    },
  },
  props: {
    pageColor: String,
  },
};
</script>

<style lang="stylus" scoped>

@require '../assets/styles/breakpoints'

.screen
  background-image: linear-gradient(150deg, #C9D9D6, #C9D9D6, white, #C9D9D6, #C9D9D6)

  @media $desktop
    background-image: linear-gradient(-7deg, #C9D9D6, #C9D9D6, white, #C9D9D6, #C9D9D6)

  &.v-enter-active,
  &.v-leave-active
    transition: filter 80ms ease

    &.v-enter,
    &.v-leave-to
      filter: blur(1px);

  // project button styles
  .project-list
    border-bottom: 1px solid black
    background-color: transparent
    color: black
    .icons
      margin-left: 300px

    &.v-enter-active,
    &.v-leave-active,
    &.v-move
      transition: transform 2000ms ease, opacity 2000ms ease

      &.v-enter,
      &.v-leave-to
        transform: translateY(60px)
        opacity: 0

    &.v-leave-active
      position: absolute
      width: 100%

    .header
      display: flex
      border-top: 1px solid black
      padding-right: 30px
      color: black

      @media $desktop
        padding-left: 160px

      @media $tablet
        padding-left: 160px

      &:focus
        background-color: black
        transition: 200ms ease
        color: white

        .projectButtons
          opacity: 1

      &:active
        background-color: black
        transition: 200ms ease
        color: white

        .projectButtons
          opacity: 1

      &:hover
        background-color: black
        transition: 200ms ease
        color: white

        .projectButtons
          opacity: 1

      &:not(:hover):not(:focus):not(:active)
        color: black

      .icon
        width: 15px !important
        height: 15px !important

        &:focus
          width: 18px !important
          height: 18px !important
          transition: 200ms ease

        &:active
          width: 18px !important
          height: 18px !important
          transition: 200ms ease

        &:hover
          width: 18px !important
          height: 18px !important
          transition: 200ms ease

      >>>.button
        background-color: transparent

        &:focus
          background-color: transparent !important

        &:active
          background-color: transparent !important

        &:hover
          background-color: transparent !important

      .showTodosButton
        font-family: futura-pt, sans-serif
        font-weight: 400;
        font-style: normal
        text-transform: uppercase
        font-size: 16px
        display: flex
        width: 100%
        padding: 16px
        padding-left: 40px
        color: black
        display: flex
        vertical-align: middle

        >>> .icon
            padding-top: 5px

        >>> .label
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis

        &:focus
          color: black
          background-color: black

        &:active
          color: white
          background-color: black

        &:hover
          color: white
          background-color: black

        &:not(:hover):not(:focus):not(:active)
          color: black

      .projectButtons
        position: absolute
        right: 0
        margin-top: 23px
        opacity: 0
        padding-right: 30px
        display: inline-flex

        @media $desktop
          margin-left: 500px
          left: 0
          right: auto


        .projectButton
          color:inherit
          outline: none
          border: none
          background-color: transparent

    // todo styles
    .todo-list
      transition: 100ms ease
      position: relative
      opacity: 1

      &.v-enter-active,
      &.v-leave-active,
      &.v-move
        transition: transform 2000ms ease, opacity 2000ms ease

        &.v-enter,
        &.v-leave-to
          transform: translateY(60px)
          opacity: 0

      &.v-leave-active
        position: absolute
        width: 100%

      .todo-item
        transition: 500ms ease
        transition: 200ms ease
        padding-right: 8px
        padding-top: 8px
        padding-bottom: 8px
        background-color: black
        color: white !important
        border-top: solid 0.5px white
        @media $desktop
          padding-left: 70px

        >>> .icon
          color: white

        &:not(:hover):not(:focus):not(:active)
          color: black

        &:focus
          color: white
          border:none
          outline: none

        &:active
          color: white
          outline: none

        &:hover
          transition: background-color 500ms ease
          color: white
          outline: none

        &.v-enter-active,
        &.v-leave-active,
        &.v-move
          transition: transform 2000ms ease, opacity 2000ms ease

          &.v-enter,
          &.v-leave-to
            transform: translateY(60px)
            opacity: 0

        &.v-leave-active
          position: absolute
          width: 100%

  // empty state styles
  .empty-state
    margin-left: 40px
    height: 60px
    color: black
    width: 85%

    .start
      display: flex
      position: absolute;
      right:0
      margin-bottom: 130px
      margin-right: 38px
      bottom: 0
      padding: 0px !important

      @media $desktop
        margin-bottom: 400px
        margin-right: 1070px

      @media $tablet
        margin-bottom: 330px
        margin-right: 800px

      span
        padding-right: 7px
        font-family: futura-pt, sans-serif
        font-weight: 400;
        font-style: normal
        text-transform: uppercase

      .icon
        padding-top: 3px
        color: black
        width: 18px
        height: 18px

        @media $tablet
          opacity: 0

</style>
